module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"modal-paying-status-waiting-body-text-1":"Transaction processing","modal-paying-status-waiting-body-text-2":"Please wait"},"zh-TW":{"modal-paying-status-waiting-body-text-1":"交易進行中","modal-paying-status-waiting-body-text-2":"請稍候"}}')
  delete Component.options._Ctor
}
